// extracted by mini-css-extract-plugin
export default {"input":"styles_input__hfkmu","inputError":"styles_inputError__It1TY","rot":"styles_rot__JNoTL"};